import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { CardApiModelStub } from '../api-models/stubs/CardApiModel.stub'

export const mockGetMyPhysicalCardSuccessResponse = (
  cardStub = CardApiModelStub.build()
) => {
  return rest.get(`/api/v3/pay/my-card/`, (_, res, ctx) => {
    return res.once(
      ctx.status(200),
      ctx.json(getResponseObject({ card: cardStub }))
    )
  })
}
